import { keyframes } from "@emotion/react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import theme from "../../theme";

// Keyframes for Gradient Animation
const gradientAnimation = keyframes`
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
`;

// Keyframes for Fade-In Effect
const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

const FooterContainer = styled.footer`
  color: white;
  background-color: #f4faff;
  padding: 2rem 1rem;
  animation: ${fadeIn} 0.8s ease-in-out;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 2rem;
`;

const Logo = styled.div`
  font-size: 35px;
  font-weight: bold;
  font-family: "Rajdhani", sans-serif;
  background: linear-gradient(90deg, #40e0d0, #205f9c);
  background-size: 200% auto;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: ${gradientAnimation} 3s linear infinite;
`;

const NavColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

const NavTitle = styled.h3`
  font-size: 1rem;
  font-weight: 600;
  color: ${theme.colors.primary};
  font-family: "Inter", sans-serif;
`;

const NavLink = styled(motion.a)`
  color: black;
  text-decoration: none;
  font-size: 0.9rem;
  opacity: 0.8;
  transition:
    opacity 0.2s,
    transform 0.2s;
  font-family: "Inter", sans-serif;

  &:hover {
    opacity: 1;
    transform: scale(1.05);
  }
`;

const NewsletterSection = styled.div`
  max-width: 300px;
`;

const InputContainer = styled.div`
  display: flex;
  align-items: center;
  background: white;
  border-radius: 20px;
  border: 1px solid black;
  padding: 2px;
  overflow: hidden;
`;

const EmailInput = styled.input`
  padding: 0.75rem;
  border: none;
  flex: 1;
  outline: none;
  font-family: "Inter", sans-serif;
  transition: all 0.3s ease-in-out;
`;

const SubmitButton = styled.button`
  background: ${theme.colors.primary};
  color: white;
  border: none;
  width: 40px; /* Set explicit width */
  height: 40px; /* Set explicit height */
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition:
    background-color 0.3s,
    transform 0.2s;
  font-size: 1.2rem;

  &:hover {
    background: ${theme.colors.buttonhover};
    transform: scale(1.05);
  }
`;

const BottomSection = styled.div`
  background-color: ${theme.colors.background.main};
`;

const BottomSectionChild = styled.div`
  color: ${theme.colors.text.tertiary};
  padding: 10px 20px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  max-width: 1200px;
  margin: 0 auto;
  font-family: "Inter", sans-serif;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    p {
      font-size: 0.8rem;
    }
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;

  a {
    color: white;
    opacity: 0.8;
    transition:
      opacity 0.2s,
      transform 0.3s;

    &:hover {
      opacity: 1;
      transform: scale(1.2);
    }
  }
`;

const NavLinkBottom = styled.a`
  text-decoration: none;
  font-size: 0.9rem;
  font-family: "Inter", sans-serif;
  transition: transform 0.2s;

  span {
    color: ${theme.colors.text.tertiary};
  }

  &:hover {
    opacity: 1;
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;

    font-size: 0.8rem;
  }
`;

const NavlinkContainer = styled.div`
  display: flex;
  alignitems: center;
  gap: 50px;
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const SC = {
  FooterContainer,
  FooterContent,
  Logo,
  NavColumn,
  NavTitle,
  NavLink,
  NewsletterSection,
  InputContainer,
  EmailInput,
  SubmitButton,
  BottomSection,
  BottomSectionChild,
  SocialLinks,
  NavLinkBottom,
  NavlinkContainer,
};

export default SC;
